// src/utils/printingUtils.ts

import { ServiceRequestArgs } from '../types/chatTypes';
import { generateServiceRequestHtml } from './htmlGenerator'; // Ajusta la ruta si es diferente

/**
 * Generates HTML for a service request and opens a print dialog.
 * @param serviceData - The data for the service request.
 * @returns true if the print window was opened, false otherwise or on error.
 */
export function printServiceRequest(serviceData: ServiceRequestArgs): boolean {
    console.log("Attempting to generate HTML for printing/PDF:", serviceData);
    try {
        const htmlContent = generateServiceRequestHtml({
            customerName: serviceData.nombre_solicitante,
            customerAddress: serviceData.ubicacion_proyecto, // Usas ubicacion_proyecto para dirección del cliente también
            customerEmail: serviceData.email_solicitante,
            customerPhone: serviceData.telefono_solicitante,
            serviceName: serviceData.nombre_servicio,
            projectLocation: serviceData.ubicacion_proyecto,
            additionalDetails: serviceData.detalles_adicionales,
            customerNotes: serviceData.notas_cliente,
        });

        const printWindow = window.open('', '_blank');
        if (printWindow) {
            printWindow.document.open();
            printWindow.document.write(htmlContent);
            printWindow.document.close();
            // Pequeño retraso para asegurar que el contenido se cargue antes de imprimir
            setTimeout(() => { printWindow.focus(); printWindow.print(); }, 250);
            console.log("Print window opened successfully.");
            return true;
        } else {
            console.warn("Print window blocked by browser.");
            alert('Tu navegador bloqueó la ventana emergente. Por favor, permite ventanas emergentes para imprimir.');
            return false;
        }
    } catch (genError) {
        console.error("Error generating or printing the HTML:", genError);
        alert("Ocurrió un error al generar el documento para PDF.");
        return false;
    }
}